module.exports = __webpack_public_path__ + "img/logo.563db8bf.png";